import Link from "next/link"


export default function Logo() {
  return (
    <div className="font-dancing font-bold text-[2rem] text-primary">
      <Link href="/">Yorumm.com</Link>
    </div>
  )
}